const handleSeprateArrayContents = (propertyToReturn, arrayToSeparate) => {
    return arrayToSeparate.map((item, i) => {
        return item && item[propertyToReturn]
            ? `${item[propertyToReturn]} ${
                  i === arrayToSeparate.length - 2 ? ' و ' : i === arrayToSeparate.length - 1 ? '' : '،'
              }`
            : '';
    });
};

export default handleSeprateArrayContents;
